import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import BaseModal from './BaseModal';
import { FieldDescriptor } from '../../types/modal/FieldDescriptor';

export interface UpdateModalSaveProps<T> {
  show: boolean;
  item: T;
  fields: FieldDescriptor<T>[];
  onClose: () => void;
  onSave: () => void;
  scrollable?: boolean;
}

const UpdateModalSave = <T,>({
  show,
  item,
  fields,
  onClose,
  onSave,
  scrollable = false,
}: UpdateModalSaveProps<T>) => {
  const renderValue = (f: FieldDescriptor<T>) => {
    const value = item[f.key];
    if (f.type === 'checkbox' && typeof value === 'boolean') {
      return value ? 'チェックあり' : 'チェックなし';
    }
    if (f.type === 'date' && typeof value === 'string') {
      return new Date(value).toLocaleDateString('ja-JP');
    }
    return String(value);
  };

  return (
    <BaseModal show={show} onHide={onClose} scrollable={scrollable}>
      {/* ヘッダー（保存系=primary） */}
      <Modal.Header className="bg-primary text-white justify-content-center">
        <Modal.Title as="h5" className="w-100 text-center m-0">
          以下の内容で更新しますか？
        </Modal.Title>
      </Modal.Header>

      {/* 本文（Bootstrapユーティリティのみ） */}
      <Modal.Body>
        <div className="mx-auto w-75 d-grid gap-3">
          {fields.map((f) => (
            <div key={String(f.key)}>
              {f.label}： {renderValue(f)}
            </div>
          ))}
        </div>
      </Modal.Body>

      {/* フッター */}
      <Modal.Footer className="justify-content-center">
        <Button variant="secondary" onClick={onClose}>
          キャンセル
        </Button>
        <Button variant="primary" onClick={onSave}>
          保存
        </Button>
      </Modal.Footer>
    </BaseModal>
  );
};

export default UpdateModalSave;
